import { arrow, autoUpdate, flip, offset as react_dom_offset, shift, size, useFloating } from "@floating-ui/react-dom";
import { getOrderedFallbackPlacements } from "./flip.js";
const useFloatingElement = ({ arrowNode, placement = 'bottom', strategy = 'fixed', offset: offsetValue = arrowNode ? 8 : 4, flip: flipEnabled = true, shift: shiftEnabled = false, oppositeAxisPlacement: oppositeAxisPlacementEnabled = true, middleware = [] })=>{
    const middlewares = [
        ...middleware,
        size({
            apply ({ availableWidth, elements }) {
                Object.assign(elements.floating.style, {
                    maxWidth: shiftEnabled || flipEnabled ? '100vw' : `${availableWidth}px`
                });
            }
        })
    ];
    if (offsetValue > 0) middlewares.push(react_dom_offset(offsetValue));
    if (shiftEnabled) middlewares.push(shift());
    if (flipEnabled) middlewares.push(flip({
        fallbackPlacements: getOrderedFallbackPlacements(placement, oppositeAxisPlacementEnabled)
    }));
    if (arrowNode) middlewares.push(arrow({
        element: arrowNode
    }));
    const { x, y, refs, middlewareData, placement: floatingUiPlacement, strategy: floatingUiStrategy, update } = useFloating({
        placement,
        strategy,
        middleware: middlewares,
        whileElementsMounted: autoUpdate
    });
    return {
        styles: getFloatingElementStyles(floatingUiStrategy, x, y),
        arrowStyles: arrowNode ? getArrowStyles(middlewareData?.arrow, floatingUiPlacement, Math.sqrt((arrowNode.getBoundingClientRect().height / 2) ** 2 / 2)) : {},
        refs,
        update
    };
};
const getFloatingElementStyles = (strategy, x, y)=>({
        position: strategy,
        top: y ?? void 0,
        left: x ?? void 0
    });
const getArrowStyles = (arrowData, placement, offset)=>{
    const staticSide = {
        top: 'bottom',
        right: 'left',
        bottom: 'top',
        left: 'right'
    }[placement.split('-')[0]] || 'bottom';
    return {
        left: arrowData?.x != null ? arrowData.x : void 0,
        top: arrowData?.y != null ? arrowData.y : void 0,
        [staticSide]: -offset
    };
};
export { useFloatingElement };
